import watchContent, { bodiesMatching } from '../utils/watchContent';
export default class LinkPreview {
  contents = [];
  content(component, bodies) {
    this.contents.push([component, typeof bodies === 'string' ? bodiesMatching(bodies) : bodies]);
    return this;
  }
  extend(app, extension) {
    this.contents.forEach(_ref => {
      let [component, bodies] = _ref;
      return watchContent(component, bodies);
    });
  }
}
flarum.reg.add('datlechin-link-preview', 'forum/extenders/LinkPreview', LinkPreview);